export default "__VITE_PUBLIC_ASSET__fb81a03f__"